// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/scss/headerimage.scss
// module id = 381
// module chunks = 2